import * as actions from './actions';

const initialState = {
    courseId: 0,
    productId: 0,
    masterCourse: {
        tree: {
            nodes: []
        }
    },
    topicTree: { childNodes: [] },
    enableSaveCourse: false,
    enablePublish: false,
    isValidationError: false,
    showSuccessSaveMessage: false,
    validationMessage: '',
    standardFilters: {},
    curriculumLevelDescriptions: [],
    isPublishModalVisible: false,
    topicTypes: [
        { value: 'Descriptor', label: 'Descriptor' },
        { value: 'Strand', label: 'Strand' },
        { value: 'Standard', label: 'Standard' },
        { value: 'LearningJourney', label: 'Learning Journey' },
        { value: 'Step', label: 'Step' }
    ]
};

const addSpineNodeIdToChildren = (nodes) => {
    nodes.map((node) => {
        // add standard code
        node.title = node.code !== '' ? `${node.code}: ${node.title}` : node.title;

        if (node.spineNodes !== null) {
            node.spineNodes.map((spineNode) => {
                spineNode.title = `${spineNode.id}: ${spineNode.description}`;
                return spineNode;
            });
            node.children = [...node.spineNodes, ...node.children];
            return node;
        }

        addSpineNodeIdToChildren(node.children);
        return node;
    });
};

export default function (state = initialState, action) {
    switch (action.type) {
    case actions.GET_MASTER_COURSE_REQUEST: {
        return {
            ...state,
            isLoading: true,
            isLoaded: false,
            courseId: 0,
            isFetching: true,
            isFetched: false,
            masterCourse: {
                tree: {
                    nodes: []
                }
            },
            genericCourse: {}
        };
    }
    case actions.GET_MASTER_COURSE_SUCCESS: {
        addSpineNodeIdToChildren(action.masterCourse.tree.nodes);
        return {
            ...state,
            masterCourse: action.masterCourse,
            curriculumLevelDescriptions: action.curriculumLevelDescriptions,
            productId: action.masterCourse.subjectId,
            isLoading: false,
            isLoaded: true,
            courseCreatorIsModified: false,
            isFetching: false,
            isFetched: true,
            standardFilters: action.strandSubStrands
        };
    }
    case actions.GET_MASTER_COURSE_FAILURE: {
        return {
            ...state,
            isLoading: false,
            isLoaded: false,
            isFetching: false,
            isFetched: false
        };
    }
    case actions.UPDATE_TOPIC_TREE_REQUEST: {
        return {
            ...state,
            topicTree: action.request,
            enableSaveCourse: true
        };
    }
    case actions.SAVE_COURSE_REQUEST: {
        return {
            ...state,
            isSaving: true,
            enableSaveCourse: false,
            isValidationError: false,
            showSuccessSaveMessage: false
        };
    }
    case actions.SAVE_COURSE_SUCCESS: {
        return {
            ...state,
            isSaving: false,
            enableSaveCourse: false,
            enablePublish: true,
            showSuccessSaveMessage: true,
            courseId: action.newCourseId,
            courseCreatorIsModified: false
        };
    }
    case actions.SAVE_COURSE_VALIDATION_ERROR: {
        return {
            ...state,
            isSaving: false,
            enableSaveCourse: true,
            enablePublish: false,
            isValidationError: true,
            validationMessage: action.message
        };
    }
    case actions.SAVE_COURSE_FAILURE: {
        return {
            ...state,
            isSaving: false,
            enableSaveCourse: true
        };
    }
    case actions.PUBLISH_COURSE_REQUEST: {
        return {
            ...state,
            isPublishing: true,
            isPublished: false,
            enablePublish: false,
            showSuccessSaveMessage: false
        };
    }
    case actions.PUBLISH_COURSE_SUCCESS: {
        return {
            ...state,
            isPublishing: false,
            isPublished: true
        };
    }
    case actions.PUBLISH_COURSE_FAILURE: {
        return {
            ...state,
            isPublishing: false,
            isPublished: false,
            enablePublish: true
        };
    }
    case actions.CANCEL_VALIDATION_ERRORS_REQUEST: {
        return {
            ...state,
            isValidationError: false,
            showSuccessSaveMessage: false,
            enableSaveCourse: false,
            enablePublish: false
        };
    }
    case actions.GET_DEFAULT_COURSE_REQUEST: {
        return {
            ...state,
            isFetching: true,
            isFetched: false,
            courseId: 0,
            pppCourse: {}
        };
    }
    case actions.GET_DEFAULT_COURSE_SUCCESS: {
        addSpineNodeIdToChildren(action.masterCourse.tree.nodes);
        return {
            ...state,
            masterCourse: action.masterCourse,
            genericCourse: action.genericCourse,
            curriculumLevelDescriptions: action.curriculumLevelDescriptions,
            assignedSpineItems: action.assignedSpineItems,
            pppCourse: action.pppCourse,
            isFetching: false,
            isFetched: true,
            standardFilters: action.strandSubStrands
        };
    }
    case actions.GET_DEFAULT_COURSE_FAILURE: {
        return {
            ...state,
            isFetching: false,
            isFetched: false
        };
    }
    case actions.OPEN_ALERT_MODAL: {
        return {
            ...state,
            isAlertVisible: true
        };
    }
    case actions.CLOSE_ALERT_MODAL: {
        return {
            ...state,
            isAlertVisible: false
        };
    }
    case actions.SET_COURSE_CREATOR_AS_MODIFIED: {
        return {
            ...state,
            enableSaveCourse: true,
            enablePublish: false,
            courseCreatorIsModified: true
        };
    }
    case actions.SET_COURSE_CREATOR_AS_CLEAN: {
        return {
            ...state,
            courseCreatorIsModified: false,
            isAlertVisible: false
        };
    }
    case actions.HIDE_TOAST: {
        return {
            ...state,
            showSuccessSaveMessage: false,
            isValidationError: false
        };
    }
    case actions.SHOW_PUBLISH_MODAL: {
        return {
            ...state,
            isPublishModalVisible: action.showModal
        };
    }
    default:
        return { ...state };
    }
}



// WEBPACK FOOTER //
// ./app/containers/course-creator/reducer.js